// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.mjs";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.mjs";
import * as PnMHelper$PorterinFeature from "../../domain/helper/PnMHelper.mjs";
import * as ExtendedAddress$PorterinFeature from "../../../fare-estimate-v1/domain/entity/ExtendedAddress.mjs";

var validators_house = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, _metadata) {
      return PnMHelper$PorterinFeature.validateHouseSize(param.show_house_field, param.house);
    })
};

var validators_mobile = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      return PnMHelper$PorterinFeature.validateMobileNumberByCountry(param.mobile, metadata.country);
    })
};

var validators_date = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      return PnMHelper$PorterinFeature.validateDateByCountry(param.date, metadata.country);
    })
};

var validators_drop = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, _metadata) {
      return PnMHelper$PorterinFeature.validateAddressWithoutBounds(param.drop);
    })
};

var validators_pickup = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, _metadata) {
      return PnMHelper$PorterinFeature.validateAddressWithoutBounds(param.pickup);
    })
};

var validators = {
  show_house_field: undefined,
  house: validators_house,
  mobile: validators_mobile,
  name: undefined,
  date: validators_date,
  drop: validators_drop,
  pickup: validators_pickup
};

function initialFieldsStatuses(_input) {
  return {
          show_house_field: /* Pristine */0,
          house: /* Pristine */0,
          mobile: /* Pristine */0,
          name: /* Pristine */0,
          date: /* Pristine */0,
          drop: /* Pristine */0,
          pickup: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match_0 = {
    TAG: /* Ok */0,
    _0: input.show_house_field
  };
  var match = fieldsStatuses.house;
  var match_0$1 = match ? match._0 : Curry._2(validators.house.validate, input, metadata);
  var match$1 = fieldsStatuses.mobile;
  var match_0$2 = match$1 ? match$1._0 : Curry._2(validators.mobile.validate, input, metadata);
  var match_0$3 = {
    TAG: /* Ok */0,
    _0: input.name
  };
  var match$2 = fieldsStatuses.date;
  var match_0$4 = match$2 ? match$2._0 : Curry._2(validators.date.validate, input, metadata);
  var match$3 = fieldsStatuses.drop;
  var match_0$5 = match$3 ? match$3._0 : Curry._2(validators.drop.validate, input, metadata);
  var match$4 = fieldsStatuses.pickup;
  var match_0$6 = match$4 ? match$4._0 : Curry._2(validators.pickup.validate, input, metadata);
  var show_house_fieldResult = match_0;
  var show_house_fieldResult$1;
  if (show_house_fieldResult.TAG === /* Ok */0) {
    var houseResult = match_0$1;
    if (houseResult.TAG === /* Ok */0) {
      var mobileResult = match_0$2;
      if (mobileResult.TAG === /* Ok */0) {
        var nameResult = match_0$3;
        if (nameResult.TAG === /* Ok */0) {
          var dateResult = match_0$4;
          if (dateResult.TAG === /* Ok */0) {
            var dropResult = match_0$5;
            if (dropResult.TAG === /* Ok */0) {
              var pickupResult = match_0$6;
              if (pickupResult.TAG === /* Ok */0) {
                return {
                        TAG: /* Valid */0,
                        output: {
                          pickup: pickupResult._0,
                          drop: dropResult._0,
                          date: dateResult._0,
                          name: nameResult._0,
                          mobile: mobileResult._0,
                          house: houseResult._0,
                          show_house_field: show_house_fieldResult._0
                        },
                        fieldsStatuses: {
                          show_house_field: /* Dirty */{
                            _0: show_house_fieldResult,
                            _1: /* Hidden */1
                          },
                          house: /* Dirty */{
                            _0: houseResult,
                            _1: /* Shown */0
                          },
                          mobile: /* Dirty */{
                            _0: mobileResult,
                            _1: /* Shown */0
                          },
                          name: /* Dirty */{
                            _0: nameResult,
                            _1: /* Hidden */1
                          },
                          date: /* Dirty */{
                            _0: dateResult,
                            _1: /* Shown */0
                          },
                          drop: /* Dirty */{
                            _0: dropResult,
                            _1: /* Shown */0
                          },
                          pickup: /* Dirty */{
                            _0: pickupResult,
                            _1: /* Shown */0
                          }
                        },
                        collectionsStatuses: undefined
                      };
              }
              show_house_fieldResult$1 = show_house_fieldResult;
            } else {
              show_house_fieldResult$1 = show_house_fieldResult;
            }
          } else {
            show_house_fieldResult$1 = show_house_fieldResult;
          }
        } else {
          show_house_fieldResult$1 = show_house_fieldResult;
        }
      } else {
        show_house_fieldResult$1 = show_house_fieldResult;
      }
    } else {
      show_house_fieldResult$1 = show_house_fieldResult;
    }
  } else {
    show_house_fieldResult$1 = show_house_fieldResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            show_house_field: /* Dirty */{
              _0: show_house_fieldResult$1,
              _1: /* Hidden */1
            },
            house: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            mobile: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            name: /* Dirty */{
              _0: match_0$3,
              _1: /* Hidden */1
            },
            date: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            drop: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            pickup: /* Dirty */{
              _0: match_0$6,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurShow_house_fieldField */0 :
                  var result = Formality.validateFieldOnBlurWithoutValidator(state.input.show_house_field, state.fieldsStatuses.show_house_field, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  show_house_field: status,
                                  house: init.house,
                                  mobile: init.mobile,
                                  name: init.name,
                                  date: init.date,
                                  drop: init.drop,
                                  pickup: init.pickup
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurHouseField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.house, validators_house, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  show_house_field: init.show_house_field,
                                  house: status,
                                  mobile: init.mobile,
                                  name: init.name,
                                  date: init.date,
                                  drop: init.drop,
                                  pickup: init.pickup
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMobileField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.mobile, validators_mobile, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  show_house_field: init.show_house_field,
                                  house: init.house,
                                  mobile: status,
                                  name: init.name,
                                  date: init.date,
                                  drop: init.drop,
                                  pickup: init.pickup
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurNameField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithoutValidator(state.input.name, state.fieldsStatuses.name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  show_house_field: init.show_house_field,
                                  house: init.house,
                                  mobile: init.mobile,
                                  name: status,
                                  date: init.date,
                                  drop: init.drop,
                                  pickup: init.pickup
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDateField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.date, validators_date, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  show_house_field: init.show_house_field,
                                  house: init.house,
                                  mobile: init.mobile,
                                  name: init.name,
                                  date: status,
                                  drop: init.drop,
                                  pickup: init.pickup
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDropField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.drop, validators_drop, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  show_house_field: init.show_house_field,
                                  house: init.house,
                                  mobile: init.mobile,
                                  name: init.name,
                                  date: init.date,
                                  drop: status,
                                  pickup: init.pickup
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPickupField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.pickup, validators_pickup, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  show_house_field: init.show_house_field,
                                  house: init.house,
                                  mobile: init.mobile,
                                  name: init.name,
                                  date: init.date,
                                  drop: init.drop,
                                  pickup: status
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */7 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              Curry._2(onSubmit, output, {
                                    notifyOnSuccess: (function (input) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmittedStatus */7,
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmissionFailedStatus */8,
                                              _0: error
                                            });
                                      }),
                                    reset: (function (param) {
                                        Curry._1(dispatch, /* Reset */10);
                                      }),
                                    dismissSubmissionResult: (function (param) {
                                        Curry._1(dispatch, /* DismissSubmissionResult */9);
                                      })
                                  });
                            })
                        };
                  break;
              case /* DismissSubmissionError */8 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */9 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */10 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateShow_house_fieldField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.show_house_field, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            show_house_field: status,
                                            house: init.house,
                                            mobile: init.mobile,
                                            name: init.name,
                                            date: init.date,
                                            drop: init.drop,
                                            pickup: init.pickup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateHouseField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.house, state.submissionStatus, validators_house, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            show_house_field: init.show_house_field,
                                            house: status,
                                            mobile: init.mobile,
                                            name: init.name,
                                            date: init.date,
                                            drop: init.drop,
                                            pickup: init.pickup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMobileField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.mobile, state.submissionStatus, validators_mobile, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            show_house_field: init.show_house_field,
                                            house: init.house,
                                            mobile: status,
                                            name: init.name,
                                            date: init.date,
                                            drop: init.drop,
                                            pickup: init.pickup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateNameField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$3.name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            show_house_field: init.show_house_field,
                                            house: init.house,
                                            mobile: init.mobile,
                                            name: status,
                                            date: init.date,
                                            drop: init.drop,
                                            pickup: init.pickup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDateField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.date, state.submissionStatus, validators_date, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            show_house_field: init.show_house_field,
                                            house: init.house,
                                            mobile: init.mobile,
                                            name: init.name,
                                            date: status,
                                            drop: init.drop,
                                            pickup: init.pickup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDropField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.drop, state.submissionStatus, validators_drop, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            show_house_field: init.show_house_field,
                                            house: init.house,
                                            mobile: init.mobile,
                                            name: init.name,
                                            date: init.date,
                                            drop: status,
                                            pickup: init.pickup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePickupField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$6, metadata, state.fieldsStatuses.pickup, state.submissionStatus, validators_pickup, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            show_house_field: init.show_house_field,
                                            house: init.house,
                                            mobile: init.mobile,
                                            name: init.name,
                                            date: init.date,
                                            drop: init.drop,
                                            pickup: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */7 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */8 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */9 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateShow_house_field: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateShow_house_fieldField */0,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateHouse: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateHouseField */1,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateMobile: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateMobileField */2,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateName: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateNameField */3,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateDate: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateDateField */4,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateDrop: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateDropField */5,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updatePickup: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdatePickupField */6,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          blurShow_house_field: (function (param) {
              Curry._1(dispatch, /* BlurShow_house_fieldField */0);
            }),
          blurHouse: (function (param) {
              Curry._1(dispatch, /* BlurHouseField */1);
            }),
          blurMobile: (function (param) {
              Curry._1(dispatch, /* BlurMobileField */2);
            }),
          blurName: (function (param) {
              Curry._1(dispatch, /* BlurNameField */3);
            }),
          blurDate: (function (param) {
              Curry._1(dispatch, /* BlurDateField */4);
            }),
          blurDrop: (function (param) {
              Curry._1(dispatch, /* BlurDropField */5);
            }),
          blurPickup: (function (param) {
              Curry._1(dispatch, /* BlurPickupField */6);
            }),
          show_house_fieldResult: Formality.exposeFieldResult(state.fieldsStatuses.show_house_field),
          houseResult: Formality.exposeFieldResult(state.fieldsStatuses.house),
          mobileResult: Formality.exposeFieldResult(state.fieldsStatuses.mobile),
          nameResult: Formality.exposeFieldResult(state.fieldsStatuses.name),
          dateResult: Formality.exposeFieldResult(state.fieldsStatuses.date),
          dropResult: Formality.exposeFieldResult(state.fieldsStatuses.drop),
          pickupResult: Formality.exposeFieldResult(state.fieldsStatuses.pickup),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.show_house_field || match.house || match.mobile || match.name || match.date || match.drop || match.pickup) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              Curry._1(dispatch, /* Submit */7);
            }),
          dismissSubmissionError: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionError */8);
            }),
          dismissSubmissionResult: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionResult */9);
            }),
          mapSubmissionError: (function (map) {
              Curry._1(dispatch, {
                    TAG: /* MapSubmissionError */9,
                    _0: map
                  });
            }),
          reset: (function (param) {
              Curry._1(dispatch, /* Reset */10);
            })
        };
}

var PnMBaseForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function initial_form_state(user, show_house_field, country) {
  var phoneNumber = user !== undefined ? Belt_Option.getWithDefault(user.mobile, "") : "";
  return {
          pickup: ExtendedAddress$PorterinFeature.initial_address(undefined),
          drop: ExtendedAddress$PorterinFeature.initial_address(undefined),
          date: PnMHelper$PorterinFeature.getMinDateByCountry(country),
          name: "",
          mobile: phoneNumber,
          house: undefined,
          show_house_field: show_house_field
        };
}

export {
  PnMBaseForm ,
  initial_form_state ,
}
/* react Not a pure module */
